/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as VoteArtworkRouteImport } from './routes/vote-artwork'
import { Route as ViewSubmissionsRouteImport } from './routes/view-submissions'
import { Route as ViewArtworkRouteImport } from './routes/view-artwork'
import { Route as SubmitArtworkRouteImport } from './routes/submit-artwork'
import { Route as ResetPasswordRouteImport } from './routes/reset-password'
import { Route as RegisterRouteImport } from './routes/register'
import { Route as ProfileRouteImport } from './routes/profile'
import { Route as PasswordResetRouteImport } from './routes/password-reset'
import { Route as LoginRouteImport } from './routes/login'
import { Route as JurorRegistrationRouteImport } from './routes/juror-registration'
import { Route as IndexRouteImport } from './routes/index'
import { Route as ViewArtworkArtworkIdRouteImport } from './routes/view-artwork_.$artworkId'
import { Route as ProfilesUserIdRouteImport } from './routes/profiles_.$userId'

const VoteArtworkRoute = VoteArtworkRouteImport.update({
  id: '/vote-artwork',
  path: '/vote-artwork',
  getParentRoute: () => rootRouteImport,
} as any)
const ViewSubmissionsRoute = ViewSubmissionsRouteImport.update({
  id: '/view-submissions',
  path: '/view-submissions',
  getParentRoute: () => rootRouteImport,
} as any)
const ViewArtworkRoute = ViewArtworkRouteImport.update({
  id: '/view-artwork',
  path: '/view-artwork',
  getParentRoute: () => rootRouteImport,
} as any)
const SubmitArtworkRoute = SubmitArtworkRouteImport.update({
  id: '/submit-artwork',
  path: '/submit-artwork',
  getParentRoute: () => rootRouteImport,
} as any)
const ResetPasswordRoute = ResetPasswordRouteImport.update({
  id: '/reset-password',
  path: '/reset-password',
  getParentRoute: () => rootRouteImport,
} as any)
const RegisterRoute = RegisterRouteImport.update({
  id: '/register',
  path: '/register',
  getParentRoute: () => rootRouteImport,
} as any)
const ProfileRoute = ProfileRouteImport.update({
  id: '/profile',
  path: '/profile',
  getParentRoute: () => rootRouteImport,
} as any)
const PasswordResetRoute = PasswordResetRouteImport.update({
  id: '/password-reset',
  path: '/password-reset',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const JurorRegistrationRoute = JurorRegistrationRouteImport.update({
  id: '/juror-registration',
  path: '/juror-registration',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const ViewArtworkArtworkIdRoute = ViewArtworkArtworkIdRouteImport.update({
  id: '/view-artwork_/$artworkId',
  path: '/view-artwork/$artworkId',
  getParentRoute: () => rootRouteImport,
} as any)
const ProfilesUserIdRoute = ProfilesUserIdRouteImport.update({
  id: '/profiles_/$userId',
  path: '/profiles/$userId',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/juror-registration': typeof JurorRegistrationRoute
  '/login': typeof LoginRoute
  '/password-reset': typeof PasswordResetRoute
  '/profile': typeof ProfileRoute
  '/register': typeof RegisterRoute
  '/reset-password': typeof ResetPasswordRoute
  '/submit-artwork': typeof SubmitArtworkRoute
  '/view-artwork': typeof ViewArtworkRoute
  '/view-submissions': typeof ViewSubmissionsRoute
  '/vote-artwork': typeof VoteArtworkRoute
  '/profiles/$userId': typeof ProfilesUserIdRoute
  '/view-artwork/$artworkId': typeof ViewArtworkArtworkIdRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/juror-registration': typeof JurorRegistrationRoute
  '/login': typeof LoginRoute
  '/password-reset': typeof PasswordResetRoute
  '/profile': typeof ProfileRoute
  '/register': typeof RegisterRoute
  '/reset-password': typeof ResetPasswordRoute
  '/submit-artwork': typeof SubmitArtworkRoute
  '/view-artwork': typeof ViewArtworkRoute
  '/view-submissions': typeof ViewSubmissionsRoute
  '/vote-artwork': typeof VoteArtworkRoute
  '/profiles/$userId': typeof ProfilesUserIdRoute
  '/view-artwork/$artworkId': typeof ViewArtworkArtworkIdRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/juror-registration': typeof JurorRegistrationRoute
  '/login': typeof LoginRoute
  '/password-reset': typeof PasswordResetRoute
  '/profile': typeof ProfileRoute
  '/register': typeof RegisterRoute
  '/reset-password': typeof ResetPasswordRoute
  '/submit-artwork': typeof SubmitArtworkRoute
  '/view-artwork': typeof ViewArtworkRoute
  '/view-submissions': typeof ViewSubmissionsRoute
  '/vote-artwork': typeof VoteArtworkRoute
  '/profiles_/$userId': typeof ProfilesUserIdRoute
  '/view-artwork_/$artworkId': typeof ViewArtworkArtworkIdRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/juror-registration'
    | '/login'
    | '/password-reset'
    | '/profile'
    | '/register'
    | '/reset-password'
    | '/submit-artwork'
    | '/view-artwork'
    | '/view-submissions'
    | '/vote-artwork'
    | '/profiles/$userId'
    | '/view-artwork/$artworkId'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/juror-registration'
    | '/login'
    | '/password-reset'
    | '/profile'
    | '/register'
    | '/reset-password'
    | '/submit-artwork'
    | '/view-artwork'
    | '/view-submissions'
    | '/vote-artwork'
    | '/profiles/$userId'
    | '/view-artwork/$artworkId'
  id:
    | '__root__'
    | '/'
    | '/juror-registration'
    | '/login'
    | '/password-reset'
    | '/profile'
    | '/register'
    | '/reset-password'
    | '/submit-artwork'
    | '/view-artwork'
    | '/view-submissions'
    | '/vote-artwork'
    | '/profiles_/$userId'
    | '/view-artwork_/$artworkId'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  JurorRegistrationRoute: typeof JurorRegistrationRoute
  LoginRoute: typeof LoginRoute
  PasswordResetRoute: typeof PasswordResetRoute
  ProfileRoute: typeof ProfileRoute
  RegisterRoute: typeof RegisterRoute
  ResetPasswordRoute: typeof ResetPasswordRoute
  SubmitArtworkRoute: typeof SubmitArtworkRoute
  ViewArtworkRoute: typeof ViewArtworkRoute
  ViewSubmissionsRoute: typeof ViewSubmissionsRoute
  VoteArtworkRoute: typeof VoteArtworkRoute
  ProfilesUserIdRoute: typeof ProfilesUserIdRoute
  ViewArtworkArtworkIdRoute: typeof ViewArtworkArtworkIdRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/vote-artwork': {
      id: '/vote-artwork'
      path: '/vote-artwork'
      fullPath: '/vote-artwork'
      preLoaderRoute: typeof VoteArtworkRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/view-submissions': {
      id: '/view-submissions'
      path: '/view-submissions'
      fullPath: '/view-submissions'
      preLoaderRoute: typeof ViewSubmissionsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/view-artwork': {
      id: '/view-artwork'
      path: '/view-artwork'
      fullPath: '/view-artwork'
      preLoaderRoute: typeof ViewArtworkRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/submit-artwork': {
      id: '/submit-artwork'
      path: '/submit-artwork'
      fullPath: '/submit-artwork'
      preLoaderRoute: typeof SubmitArtworkRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reset-password': {
      id: '/reset-password'
      path: '/reset-password'
      fullPath: '/reset-password'
      preLoaderRoute: typeof ResetPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/register': {
      id: '/register'
      path: '/register'
      fullPath: '/register'
      preLoaderRoute: typeof RegisterRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/profile': {
      id: '/profile'
      path: '/profile'
      fullPath: '/profile'
      preLoaderRoute: typeof ProfileRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/password-reset': {
      id: '/password-reset'
      path: '/password-reset'
      fullPath: '/password-reset'
      preLoaderRoute: typeof PasswordResetRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/juror-registration': {
      id: '/juror-registration'
      path: '/juror-registration'
      fullPath: '/juror-registration'
      preLoaderRoute: typeof JurorRegistrationRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/view-artwork_/$artworkId': {
      id: '/view-artwork_/$artworkId'
      path: '/view-artwork/$artworkId'
      fullPath: '/view-artwork/$artworkId'
      preLoaderRoute: typeof ViewArtworkArtworkIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/profiles_/$userId': {
      id: '/profiles_/$userId'
      path: '/profiles/$userId'
      fullPath: '/profiles/$userId'
      preLoaderRoute: typeof ProfilesUserIdRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  JurorRegistrationRoute: JurorRegistrationRoute,
  LoginRoute: LoginRoute,
  PasswordResetRoute: PasswordResetRoute,
  ProfileRoute: ProfileRoute,
  RegisterRoute: RegisterRoute,
  ResetPasswordRoute: ResetPasswordRoute,
  SubmitArtworkRoute: SubmitArtworkRoute,
  ViewArtworkRoute: ViewArtworkRoute,
  ViewSubmissionsRoute: ViewSubmissionsRoute,
  VoteArtworkRoute: VoteArtworkRoute,
  ProfilesUserIdRoute: ProfilesUserIdRoute,
  ViewArtworkArtworkIdRoute: ViewArtworkArtworkIdRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
